"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const wrappers_1 = require("quasar/wrappers");
const titleMixin_1 = __importDefault(require("../mixins/titleMixin"));
const uiMixin_1 = __importDefault(require("../mixins/uiMixin"));
exports.default = wrappers_1.boot(({ app }) => {
    app.mixin(titleMixin_1.default);
    app.mixin(uiMixin_1.default);
});
